export default function(data,filename){
  if (window.navigator.msSaveOrOpenBlob) {
       let blob1 = new Blob([data], {
         type: "application/vnd.ms-excel"
       });
       navigator.msSaveBlob(blob1, filename); //filename文件名包括扩展名，下载路径为浏览器默认路径

     } else {
       let blob1 = new Blob([data], {
         type: "application/vnd.ms-excel"
       });
       let href = URL.createObjectURL(blob1)
       let downloadElement = document.createElement('a');
       downloadElement.href = href;
       downloadElement.download = filename; //下载后文件名
       document.body.appendChild(downloadElement);
       downloadElement.click(); //点击下载
       document.body.removeChild(downloadElement); //下载完成移除元素
       window.URL.revokeObjectURL(href); //释放掉blob对象
     }
}


// WEBPACK FOOTER //
// ./src/common/js/Download.js